export function notVisible(el) {
  const style = window.getComputedStyle(el);
  return style.display === 'none';
}

export function isVisible(el) {
  return !notVisible(el);
}
